"use client";

import { motion } from "framer-motion";
import Link from "next/link";
import { useLang } from "@/contexts/language-context";
import { ArrowRight } from "lucide-react";

export default function DeliveryCta() {
  const { t } = useLang();

  return (
    <section className="relative py-32 px-6 bg-redy-charcoal text-white overflow-hidden">
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(244,114,43,0.20) 0%, transparent 60%)" }}
      />

      <div className="relative max-w-[800px] mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
        >
          <div className="text-[11px] font-black tracking-widest uppercase mb-6" style={{ color: "#F4722B" }}>
            {t(
              "Example: $11.25 at 25% commission vs from $2.99 — on the same $45 order.",
              "Ejemplo: $11.25 con 25% de comisión vs desde $2.99 — en el mismo pedido de $45."
            )}
          </div>
          <h2 className="text-4xl md:text-[72px] font-black tracking-[-0.03em] leading-[1.02] mb-8">
            {t("Let them find you.", "Que te encuentren ahí.")}
            <br />
            <span
              style={{
                background: "linear-gradient(135deg, #F4722B 0%, #FCA17D 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
              }}
            >
              {t("Bring them home.", "Tráelos a casa.")}
            </span>
          </h2>
          <p className="text-[16px] md:text-[18px] font-medium text-white/60 max-w-[560px] mx-auto leading-relaxed mb-10">
            {t(
              "Keep DoorDash for discovery if it earns its keep. Move the regulars to your own page, with couriers from Uber Direct, at 0% commission. Delivery is in pilot — Redy turns it on location by location.",
              "Quédate con DoorDash para descubrimiento si se lo gana. Mueve a tus clientes de siempre a tu propia página, con couriers de Uber Direct, a 0% de comisión. Delivery está en piloto — Redy lo enciende local por local."
            )}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              href="/signup"
              className="group inline-flex items-center gap-2 text-[15px] font-bold text-redy-charcoal px-8 py-4 rounded-full hover:scale-[1.03] transition-transform shadow-2xl"
              style={{
                background: "linear-gradient(135deg, #F4722B 0%, #D7263D 100%)",
                boxShadow: "0 20px 50px rgba(244, 114, 43, 0.4)",
              }}
            >
              {t("Request Delivery →", "Solicitar Delivery →")}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Link>
            <Link
              href="/features/online-ordering"
              className="inline-flex items-center text-[14px] font-bold text-white/70 hover:text-white transition-colors px-4 py-2"
            >
              {t("See online ordering →", "Ver pedidos en línea →")}
            </Link>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
